import type { FC } from 'react';

import { type ToggleField, ToggleSwitch } from '@/components/ToggleSwitch';

interface ToggleDemoSwitchProps {
  isDemo: boolean;
  handleToggleDemo: () => void;
  horizontal?: boolean;
  isDemoAvailable: boolean;
}

export const ToggleDemoSwitch: FC<ToggleDemoSwitchProps> = ({
  isDemo,
  handleToggleDemo,
  isDemoAvailable,
  ...rest
}) => {
  const fields: ToggleField[] = [
    {
      value: 'real',
      label: 'real',
      isActive: !isDemo,
    },
    ...(isDemoAvailable
      ? [
          {
            value: 'demo',
            label: 'demo',
            isActive: isDemo,
          },
        ]
      : []),
  ];

  const handleToggle = (value: string) => {
    if (fields.find((field) => field.value === value)?.isActive) return;
    handleToggleDemo();
  };

  return <ToggleSwitch fields={fields} handleToggle={handleToggle} {...rest} />;
};
